import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../global/Layout';

export default function SignInCodeErrorPage() {
    const message =
        "Your sign-in code is invalid or has expired. Please request a new one to continue.";
    return (
        <Layout>
            <main className="rs-main">
                <section className="rs-card rs-card--error">
                    <div className="rs-error__icon" aria-hidden>
                        <svg viewBox="0 0 48 48" className="rs-error__svg">
                            <circle cx="24" cy="24" r="22" className="rs-error__ring" />
                            <path d="M16 16 L32 32 M32 16 L16 32" className="rs-error__line" />
                        </svg>
                    </div>

                    <div className="rs-error__meta">
                        <h1 className="rs-error__title">
                            Sign-in Error
                        </h1>
                        <p className="rs-error__subtitle">{message}</p>

                        <div className="rs-error__actions">
                            <Link to="/login" className="rs-btn rs-btn--primary">
                                <span className="rs-btn__icon">🔑</span>
                                Back to Login
                            </Link>
                        </div>
                    </div>
                </section>
            </main>
        </Layout>
    );
}